export default "__VITE_ASSET__CVm03xQX__ 55w, __VITE_ASSET__wuu$kc_u__ 110w, __VITE_ASSET__YtU3mJZs__ 220w";